import Image from 'next/image';

export const RoleplayFeatureCard = () => {
  return (
    <section id="features" className="w-full max-w-screen-lg mx-auto mt-[48px]">
      <h2 className="text-center text-[16px] font-light text-wtf-persianRed">
        AI Roleplay in AI Porn Chat
      </h2>

      <div className="flex flex-col gap-[48px] list-none p-0">
        <article className="flex flex-col items-center px-4 md:flex-row">
          <div className="w-320 shadow-darkRed max-w-80 h-120 relative overflow-hidden rounded-[16px] lg:mr-10">
            <img
              src={'/sections/ai-porn-chat/brunette.jpg'}
              alt="AI Chatbot card of ai character"
              width={328}
              height={120}
              className="rounded-[12px]"
            />
          </div>
          <div className="w-full md:w-1/2 md:px-4 lg:mx-0 text-wtf-white">
            <h3 className="ml-0 text-3xl font-bold m-[20px]">
              Wild Scenarios for Your AI Porn Chat
            </h3>
            <p className={'text-xs'}>
              Have you ever dreamed of a wild roleplay where you&apos;re caught
              by a hot security girl? How about meeting a pop singer after her
              concert in her dressing room? Or maybe the classic nurse girl
              fantasy?
            </p>
            <p className={'text-xs'}>
              Everything and more is possible in our chat. You&apos;re the main
              character in every girl’s life here, and they&apos;re waiting for
              you to finally appear. The best porn chat AI is ready for you to
              try it!
            </p>
          </div>
        </article>
      </div>
    </section>
  );
};
